import Api from 'src/api/Base'

class SkuGzImport extends Api {
  requestUrl = `/api/import/sku/gz`

  method = 'POST'

  formatRequestData = params => params.formData
}

export default SkuGzImport
